import i18n from "@/i18n";
import requireAuthorization from "@/routes/helper/requireAuthorization";
import { PermitionEnum } from "@/components/security/Permitions";

export default [
    {
        path: "/contracts",
        name: "contracts",
        component: () => import("@/components/contracts/_Contracts.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.ViewContractsUI,
            breadcrumbs: {
                icon: "contracts-icon",
                paths: []
            },
            title: "navbar.contracts"
        }
    },
    {
        path: "/contracts/:contractId",
        name: "selectedLicense",
        component: () => import("@/components/contracts/_Contracts.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.ViewContractsUI,
            breadcrumbs: {
                icon: "contracts-icon",
                paths: [
                    ["/contracts", i18n.t("contract.title")]
                ]
            }
        },
        props: true
    }
];
